import React from 'react';
import { VIDEO_ACCEPT } from './useCardVideoUpload';

interface MediaUploadZoneFileInputProps {
  inputRef: React.RefObject<HTMLInputElement>;
  onFiles: (files: File[]) => void;
}

/** Hidden file input backing the video library upload dropzone's click-to-choose path. */
export default function MediaUploadZoneFileInput({
  inputRef,
  onFiles,
}: MediaUploadZoneFileInputProps) {
  return (
    <input
      type="file"
      multiple
      accept={VIDEO_ACCEPT}
      ref={inputRef}
      style={{ display: 'none' }}
      onChange={(event) => {
        onFiles(Array.from(event.target.files ?? []));
        event.target.value = '';
      }}
    />
  );
}
